import { Injectable, SkipSelf } from '@angular/core';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { EnvService } from 'src/app/env.service';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { ApiEndPointsForms } from '../common/apiUrls/api-end-points-forms';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class FormsService {
  private baseUrl: any;
  private baseUrlTrans: any;
  private baseUrlRole: any;
  private baseURlOrg: any;
  private baseManageUserUrl: any;
  private isProjectExtended: boolean;
  private settingbaseUrl: any;
  baseUrlTask: string;
  private baseUrlCore: any;
  constructor(
    private _http: HttpClient,
    private apiAddress: ApiEndPointsForms,
    public env: EnvService,
    private constant: Constants
  ) {
    this.isProjectExtended = false;
    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseUrl = this.constant.ManageContactsportNumber;
    else
      this.baseUrl = this.env.apiUrl + this.constant.ManageContactsportNumber;
    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseUrlTrans = this.constant.ManageTranscationportNumber;
    else
      this.baseUrlTrans =
        this.env.apiUrl + this.constant.ManageTranscationportNumber;
    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseUrlRole = this.constant.RolePortNumber;
    else this.baseUrlRole = this.env.apiUrl + this.constant.RolePortNumber;
    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseURlOrg = this.constant.ManageOrganizationPortNumber;
    else
      this.baseURlOrg = this.env.apiUrl + this.constant.ManageOrganizationPortNumber;
    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseManageUserUrl = this.constant.ManageUserPortNumber;
    else
      this.baseManageUserUrl = this.env.apiUrl + this.constant.ManageUserPortNumber;
    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseUrlTask = this.constant.ManageTask;
    else
      this.baseUrlTask = this.env.apiUrl + this.constant.ManageTask;
      if (this.env.apiUrl == undefined || this.env.apiUrl == '')
        this.settingbaseUrl = this.constant.SettingsPortNumber;
      else
        this.settingbaseUrl = this.env.apiUrl + this.constant.SettingsPortNumber;
        if (this.env.apiUrl == undefined || this.env.apiUrl == '')
          this.baseUrlCore = this.constant.ManageCoreportNumber;
        else
          this.baseUrlCore = this.env.apiUrl + this.constant.ManageCoreportNumber;
  }

  // private baseUrl = this.env.apiUrl+this.constant.ManageContactsportNumber;
  // private baseUrlTrans = this.constant.ManageTranscationportNumber;
  // //private baseUrlTrans = this.env.apiUrl+this.constant.ManageTranscationportNumber;
  // private baseUrlRole = this.constant.RolePortNumber;
  //private baseUrlRole = this.env.apiUrl+this.constant.RolePortNumber;

  CreateProjectFromFormLink(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.CreateProjectFromFormLink;
    //const apiURL = 'http://localhost:51865/' + this.apiAddress.CreateProjectFromFormLink;
    return this._http.post(apiURL, reqModel).pipe();
  }

  matchFormFolderUrlParameter(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.matchFormFolderUrlParameter;   
    return this._http.post(apiURL, reqModel).pipe();
  }

  getUserDetailsManageUser(userID): Observable<any> {
    const apiURL = this.baseManageUserUrl + this.apiAddress.getLoggedInUserDetailsManageUser;
    return this._http.post(apiURL, userID);
  }
  getUserOffices(userID): Observable<any> {
    const apiURL = this.baseManageUserUrl + this.apiAddress.getUserOffices;
    return this._http.post(apiURL, userID);
  }
  validateToken(validateTokenReqModel: any) {
    const apiCallingURl = this.baseManageUserUrl + this.apiAddress.validateUser;
    return this._http.post(apiCallingURl, validateTokenReqModel).pipe();
  }
  ShareFormFolder(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.ShareFormFolder;
    return this._http.post(apiURL, reqModel).pipe();
  }

  ShareForm(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.ShareForm;
    return this._http.post(apiURL, reqModel).pipe();
  }

  ModifyShareFormFolder(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.ModifyShareFormFolder;
    return this._http.post(apiURL, reqModel).pipe();
  }

  ModifyShareForm(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.ModifyShareForm;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getFormFolderList(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getFormFolderList;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getFormFolderSharedWithMeList(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getFormFolderSharedWithMe;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetFormTemplateCategories(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getFormTemplateCategories;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getFormFolderWithFormTemplatesSharedWithMe(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getFormFolderWithFormTemplatesSharedWithMe;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getFileManagerFolders(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getFileManagerFolders;
    return this._http.post(apiURL, reqModel).pipe();
  }

  FileManagerFoldersWithHierarchy(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.FileManagerFoldersWithHierarchy;
    return this._http.post(apiURL, reqModel).pipe();
  }

  MergeTemplate(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.MergeTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  UseFormsTemplateForProject(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.UseFormsTemplateForProject;
    return this._http.post(apiURL, reqModel).pipe();
  }

  UseMasterTemplateForProject(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.UseMasterTemplateForProject;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getFormFolderWithFormTemplates(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getFormFolderWithFormTemplates;
    //  const apiURL = "https://localhost:54717/" + this.apiAddress.getFormFolderWithFormTemplates;
    return this._http.post(apiURL, reqModel).pipe();
  }

  // MergeTemplate(reqModel): Observable<any> {
  //   const apiURL =
  //     this.baseUrlTrans + this.apiAddress.MergeTemplate;
  //   return this._http.post(apiURL, reqModel).pipe();
  // }

  GetParentFormFolderHierarchy(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetParentFormFolderHierarchy;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetFormFolderDetail(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetFormFolderDetail;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetFormDetail(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetFormDetail;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddFormFolder(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddFormFolder;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetAllFormTouches(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetAllFormTouches;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddFormTouch(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddFormTouch;
    return this._http.post(apiURL, reqModel).pipe();
  }

  RenameFormFolder(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.RenameFormFolder;
    return this._http.post(apiURL, reqModel).pipe();
  }

  configureFormFolderUrls(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.configureFormFolderUrls;
    return this._http.post(apiURL, reqModel).pipe();
  }

  setIsprojectExtended(value: boolean) {
    this.isProjectExtended = value;
  }

  getIsprojectExtended() {
    return this.isProjectExtended;
  }

  RenameForm(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.RenameForm;
    return this._http.post(apiURL, reqModel).pipe();
  }

  DeleteFormFolder(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.DeleteFormFolder;
    return this._http.post(apiURL, reqModel).pipe();
  }

  DeleteFormItems(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.DeleteFormItems;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetAllFormSharedTo(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetAllFormSharedTo;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetAllFromFolderSharedRole(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetAllFromFolderSharedRole;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddFormFavorite(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddFormFavorite;
    return this._http.post(apiURL, reqModel).pipe();
  }

  RemoveDashboardFavoriteItem (reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.RemoveDashboardFavoriteItem ;
    return this._http.post(apiURL, reqModel).pipe();
  }

  DeleteFormFavorite(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.DeleteFormFavorite;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddEditProjectGroup(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddEditProjectGroup;
    return this._http.post(apiURL, reqModel).pipe();
  }

  UpdateProjectGroupName(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddEditProjectGroup;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetGroupList(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetGroupList;
    //const apiURL = 'http://localhost:51865/' + this.apiAddress.GetGroupList;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddRecentlyViewFolder(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddRecentlyViewFolder;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetRecentlyViewFolders(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetRecentlyViewFolders;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddProjectStepFirst(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddProjectStepFirst;
   // const apiURL ="https://localhost:65454/" + this.apiAddress.AddProjectStepFirst;
    return this._http.post(apiURL, reqModel).pipe();
  }

  CheckIfPDFWillConvertToImage(reqModel): Observable<any> {
    const apiURL = "https://ecmpdftoimgapp-staging.azurewebsites.net/api/Convertor/CheckIfPDFWillConvertToImage";
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddProjectStepSecond(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddProjectStep2;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddParticipantJsonStep3(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddParticipantJsonStep3;
    return this._http.post(apiURL, reqModel).pipe();
  }

  UploadBlankImageToFormOrProject(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.UploadBlankImageToFormOrProject;
    return this._http.post(apiURL, reqModel).pipe();
  }
  GeneratePDF(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GeneratePDF;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetProjectDocuments(reqModel): Observable<any> {
    // const apiURL = this.baseUrlTrans + this.apiAddress.GetProjectDocuments;
    const apiURL = this.baseUrlTrans + this.apiAddress.GetProjectDocuments;
    return this._http.post(apiURL, reqModel).pipe();
  }

  UpdatePartcipantMessage(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.UpdatePartcipantMessage;
    //const apiURL = 'http://localhost:51865/' + this.apiAddress.UpdatePartcipantMessage;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getAttachment(fileName, filePath): Observable<any> {
    const queryParam = '?fileName=' + filePath;
    const apiURL = this.baseUrlTrans + this.apiAddress.getAttachment + '' + queryParam;
    return this._http.get(apiURL).pipe();
  }

  getTransactinalRoles(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getTransactinalRoles;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddEditProjectGroupRelationParticipant(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddEditProjectGroupRelationParticipant;
    return this._http.post(apiURL, reqModel).pipe();
  }

  UpdateParticipantDeatil(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.UpdateParticipantDeatil;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetContactListCoreImplementation(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetContactListCoreImplementation;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getSharedAccessRoles(reqModel): Observable<any> {
    const apiURL = this.baseUrlRole + this.apiAddress.getSharedAccesslRoles;
    return this._http.post(apiURL, reqModel).pipe();
  }

  RemoveGroupRelation(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.RemoveGroupRelation;
    return this._http.post(apiURL, reqModel).pipe();
  }

  ReorderFormGroupRelations(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.ReorderFormGroupRelations;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getDraftedProjects(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getDraftedProjects;
    return this._http.post(apiURL, reqModel).pipe();
  }

  deleteDraftedProjects(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.DeleteDraftedprojects;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getProjectFormEditorDetails(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetProjectFormEditorDetails;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddProjectInfoAsTemplete(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddProjectInfoAsTemplete;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetTaskGroupsByTaskList(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.GetTaskGroupsByTaskList;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addTasklist(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.addTasklist;
    return this._http.post(apiURL, reqModel).pipe();
  }

  renameTasklist(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.renameTasklist;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetExterURLToken(reqModel): Observable<any> {
    const apiURL = this.baseManageUserUrl + this.apiAddress.GetExterURLToken;
    return this._http.post(apiURL, reqModel).pipe();
  }
  SendExternalURLEmail(reqModel): Observable<any> {
    const apiURL = this.baseManageUserUrl + this.apiAddress.SendExternalURLEmail;
    return this._http.post(apiURL, reqModel).pipe();
  }
  GetProjectParticicpantWithSigningLinkByProjectID(reqModel): Observable<any> {
    // const apiURL = 'http://localhost:51865/' + this.apiAddress.GetProjectParticicpantWithSigningLinkByProjectID;
    const apiURL = this.baseUrlTrans + this.apiAddress.GetProjectParticicpantWithSigningLinkByProjectID;
    return this._http.post(apiURL, reqModel).pipe();
  }
  UpdateTaskOrTaskListstatus(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.UpdateTaskOrTaskListstatus;
    return this._http.post(apiURL, reqModel).pipe();
  }
  UpdateSingleTaskStatus(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.UpdateSingleTaskStatus;
    return this._http.post(apiURL, reqModel).pipe();
  }
  UpdateTaskPriority(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.UpdateTaskPriority;
    return this._http.post(apiURL, reqModel).pipe();
  }
  GetTemplateByID(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.GetTemplateByID;
    return this._http.post(apiURL, reqModel).pipe();
  }
  Save3cNew(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.AddTask3c;
    return this._http.post(apiURL, reqModel).pipe();
  }
  ChangeFormFolders(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.ChangeFormFolders;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddmessageStep4(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddmessageStep4;
    return this._http.post(apiURL, reqModel).pipe();
  }

  CheckProjectNames(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.CheckProjectNames;
    return this._http.post(apiURL, reqModel).pipe();
  }

  CheckProjectTemplateName(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.CheckProjectTemplateName;
    return this._http.post(apiURL, reqModel).pipe();
  }

  SearchFormFolders(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.searchFormFolders;
    return this._http.post(apiURL, reqModel).pipe();
  }

  DeletePrivateMessage(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.DeletePrivateMessage;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getInboxProjects(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getInboxProjects;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getSentProjects(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getSentProjects;
    return this._http.post(apiURL, reqModel).pipe();
  }

  DeleteInboxSentProjects(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.deleteInboxSentProjects;
    return this._http.post(apiURL, reqModel).pipe();
  }

  DeleteInboxProjects(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.DeleteInboxProjects;
    return this._http.post(apiURL, reqModel).pipe();
  }

  DeleteSentProjects(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.DeleteSentProjects;
    return this._http.post(apiURL, reqModel).pipe();
  }

  MoveSentProjectsToTrash(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.moveSentProjectsToTrash;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetTrashBoxItems(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetTrashBoxItems;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getParticipantJson(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getParticipantJson;
    return this._http.post(apiURL, reqModel).pipe();
  }
  GetSignNowJson(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetSignNowJson;
    return this._http.post(apiURL, reqModel).pipe();
  }
  getTabularJson(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getTabularJson;
    return this._http.post(apiURL, reqModel).pipe();
  }

  updateParticipantJson(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.updateParticipantJson;
    return this._http.post(apiURL, reqModel).pipe();
  }
  SaveSigningParticipantJson(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.SaveSigningParticipantJson;
    return this._http.post(apiURL, reqModel).pipe();
  }
  SaveSignNowDocuments(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.SaveSignNowDocuments;
    return this._http.post(apiURL, reqModel).pipe();
  }
  UpdateTabularJson(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.UpdateTabularJson;
    return this._http.post(apiURL, reqModel).pipe();
  }

  MakeCopyOfFormTemplate(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.MakeCopyOfFormTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  
  MakeMasterCopyOfFormTemplate(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.MakeMasterCopyOfFormTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  copyAFormFromAOffice(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.copyAFormFromAOffice;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetSentBoxItemParticipantList(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetSentBoxItemParticipantList;
    return this._http.post(apiURL, reqModel).pipe();
  }

  EditParticipantEmail(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.EditParticipantEmail;
    return this._http.post(apiURL, reqModel).pipe();
  }

  remindParticipant(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.remindParticipant;
    return this._http.post(apiURL, reqModel).pipe();
  }

  ResendEmail(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.ResendEmail;
    return this._http.post(apiURL, reqModel).pipe();
  }

  ResendRemainderProjectReport(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.ResendRemainderProjectReport;
    return this._http.post(apiURL, reqModel).pipe();
  }

  ReopenSignatureLink(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.ReopenSignatureLink;
    return this._http.post(apiURL, reqModel).pipe();
  }
  renewProject(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.RenewProject;
    return this._http.post(apiURL, reqModel).pipe();
  }

  retryPdfToImage(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.RetryPdfToImage;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddAIDocuments(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddAIDocuments;
    return this._http.post(apiURL, reqModel).pipe();
  }
  GetResponseFromAIDoc(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetResponseFromAIDoc;
    return this._http.post(apiURL, reqModel).pipe();
  }
  GetAIDocuments(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetAIDocuments;
    return this._http.post(apiURL, reqModel).pipe();
  }
  DeleteAIDocuments(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.DeleteAIDocuments;
    return this._http.post(apiURL, reqModel).pipe();
  }

  ReplaceExistingPDF(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.ReplaceExistingPDF;
    return this._http.post(apiURL, reqModel).pipe();
  }

  compressPDF(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.CompressPDF;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetPageCount(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetPageCount;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddProjectAttachmentDocument(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddProjectAttachmentDocument;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getInboxItemParticipantList(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetInBoxItemParticipantList;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getFieldValuesForAutoFill(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetContactDetailForAutoFill;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getFieldValuesForAutoFillCore(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetCoreDetailForAutoFill;
    return this._http.post(apiURL, reqModel).pipe();
  }

  declineForm(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.declineForm;
    return this._http.post(apiURL, reqModel).pipe();
  }

  FileManagerItemsWithHierarchy(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.FileManagerItemsWithHierarchy;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getFoldersListForFML(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getFileManagerFolderList;
    return this._http.post(apiURL, reqModel).pipe();
  }

  RequestCCCUrlVisit(reqModel, type): Observable<any> {
    if (type.toLowerCase() == "core") {
      const apiURL = this.baseUrlTrans + this.apiAddress.RequestCoreUrlVisit;
      return this._http.post(apiURL, reqModel).pipe();
    }
    if (type.toLowerCase() == "contact") {
      const apiURL = this.baseUrlTrans + this.apiAddress.RequestContactUrlVisit;
      return this._http.post(apiURL, reqModel).pipe();
    }
    if (type.toLowerCase() == "company") {
      const apiURL = this.baseUrlTrans + this.apiAddress.RequestCompanyUrlVisit;
      return this._http.post(apiURL, reqModel).pipe();
    }
  }

  // RequestContactUrlVisit(reqModel): Observable<any> {
  //   const apiURL = this.baseUrlTrans + this.apiAddress.RequestContactUrlVisit;
  //   return this._http.post(apiURL, reqModel).pipe();
  // }

  // RequestCompanyUrlVisit(reqModel): Observable<any> {
  //   const apiURL = this.baseUrlTrans + this.apiAddress.RequestCompanyUrlVisit;
  //   return this._http.post(apiURL, reqModel).pipe();
  // }

  ParticipantDocumentUploadCCC(reqModel, type): Observable<any> {
    if (type.toLowerCase() == "core") {
      const apiURL = this.baseUrlTrans + this.apiAddress.ParticipantDocumentUploadCore;
      return this._http.post(apiURL, reqModel).pipe();
    }
    if (type.toLowerCase() == "contact") {
      const apiURL = this.baseUrlTrans + this.apiAddress.ParticipantDocumentUploadContact;
      return this._http.post(apiURL, reqModel).pipe();
    }
    if (type.toLowerCase() == "company") {
      const apiURL = this.baseUrlTrans + this.apiAddress.ParticipantDocumentUploadCompany;
      return this._http.post(apiURL, reqModel).pipe();
    }
  }

  ParticipantDocumentUploadCore(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.ParticipantDocumentUploadCore;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddProjectEventLog(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddProjectEventLog;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetProjectAuditLog(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetProjectAuditLog;
    return this._http.post(apiURL, reqModel).pipe();
  }

  NotificationPost(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.NotificationPost;
    //return this._http.post(apiURL, reqModel).pipe();
    return new Observable<Object>();
  }

  // To get Notification List
  getNotificationList(data: any): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.NotificationList;
    //  return this._http.post(apiURL, data).pipe();
    return new Observable<Object>();
  }

  // To get Unread Notification count
  GetUnreadNotificationsCount(data: any): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetUnreadNotificationsCount;
    //  return this._http.post(apiURL, data).pipe();
    return new Observable<Object>();
  }

  // MarkUnreadNotifications
  MarkUnreadNotifications(data: any): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.MarkUnreadNotifications;
    //return this._http.post(apiURL, data).pipe();
    return new Observable<Object>();
  }

  AddHtMLForm(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddHtMLForm;
    //const apiURL = "https://localhost:54717/"  + this.apiAddress.AddHtMLForm;
    return this._http.post(apiURL, reqModel).pipe();
  }

  UpdateHTMLForm(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.UpdateHTMLForm;
    //const apiURL = "https://localhost:54119/"  + this.apiAddress.UpdateHTMLForm;
    return this._http.post(apiURL, reqModel).pipe();
  }

  searchTransCities(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.searchTransCities;
    return this._http.post(apiURL, reqModel).pipe();
  }

  searchTransZip(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.searchTransZip;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getStateList(countryId): Observable<any> {
    const apiCallingURl = this.baseURlOrg + this.apiAddress.getStateList;
    return this._http.post(apiCallingURl, countryId).pipe();
  }

  getDashboardStats(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getDashboardStats;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getDashboard3cGraphData(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getDashboard3cGraphData;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddDashboardFavoriteItem(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddDashboardFavoriteItem;
    return this._http.post(apiURL, reqModel).pipe();
  }

  DashboardFavoriteItems(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.DashboardFavoriteItems;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getDashboardSignatureGraphData(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getDashboardSignatureGraphData;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addNote(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.addNote;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getNotes(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getNotes;
    return this._http.post(apiURL, reqModel).pipe();
  }

  deleteNotes(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.deleteNotes;
    return this._http.post(apiURL, reqModel).pipe();
  }
  deletePortalNotes(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.deletePortalNotes;
   // return this._http.post(apiURL, reqModel).pipe();


   // const apiURL = this.baseUrlTrans + this.apiAddress.addPersonalNote;   
    // Retrieve the token from local storage
    const token = sessionStorage.getItem('LoginToken');

    // Prepare the headers
    const httpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });
    return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();

  }

  getCCCList(reqModel, type): Observable<any> {
    if (type == "Core") {
      const apiURL = this.baseUrlTrans + this.apiAddress.getCoreListing;
      return this._http.post(apiURL, reqModel).pipe();
    }
    if (type == "Contact") {
      const apiURL = this.baseUrlTrans + this.apiAddress.getContactListing;
      return this._http.post(apiURL, reqModel).pipe();
    }
    if (type == "Company") {
      const apiURL = this.baseUrlTrans + this.apiAddress.getCompanyListing;
      return this._http.post(apiURL, reqModel).pipe();
    }
  }

  GetSharedWithMeFileManager(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetSharedWithMeFileManager;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetSharedWithMeFileManagerWithHierarchy(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetSharedWithMeFileManagerWithHierarchy;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetMasterTemplateCategoryList(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getFormTemplateCategories;
    return this._http.post(apiURL, reqModel).pipe();
  }

  updateProjectGroupRelationName(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.updateProjectGroupRelationName;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getProjectFinalDocuments(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getProjectFinalDocuments;
    return this._http.post(apiURL, reqModel).pipe();
  }

  generateFinalDocumentsThroughSignaturePage(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.generateFinalDocumentsThroughSignaturePage;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GenerateFInalDocumentsThroughSignaturePageNewPDFFunctionality(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GenerateFInalDocumentsThroughSignaturePageNewPDFFunctionality;
    return this._http.post(apiURL, reqModel).pipe();
  }

  projectFinishBySender(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.projectFinishBySender;
    return this._http.post(apiURL, reqModel).pipe();
  }


  getHtmlForm(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getFormHtml;   
    return this._http.post(apiURL, reqModel).pipe();
  }

  getHtmlFormData(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getHtmlFormData;    
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetProjectsByFormID(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetProjectsByFormID;   
    return this._http.post(apiURL, reqModel).pipe();
  }

  DownloadMultipleAsZipAsync(reqModel: any): Promise<Blob> {
    const endpoint = this.baseUrlTrans + this.apiAddress.DownloadMultipleAsZipAsync;
    return this._http.post(endpoint,reqModel, { responseType: 'blob' }).toPromise();
  }

  FetchDocAsync(reqModel: any): Promise<Blob> {
    const endpoint = this.baseUrlTrans + this.apiAddress.FetchDocAsync;
    return this._http.post(endpoint,reqModel, { responseType: 'blob' }).toPromise();
  }
  SubmitHTMLForm(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.SubmitHTMLForm;   
    return this._http.post(apiURL, reqModel).pipe();
  }

  getOrganizationFormTemplateGallery(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getOrganizationFormTemplateGallery;  
    return this._http.post(apiURL, reqModel).pipe();
  }


  addSignature(reqModel): Observable<any> {
    const apiURL = this.baseManageUserUrl + this.apiAddress.addSignature;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addDefaultSignature(reqModel): Observable<any> {
    const apiURL = this.baseManageUserUrl + this.apiAddress.addDefaultSignature;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addInitial(reqModel): Observable<any> {
    const apiURL = this.baseManageUserUrl + this.apiAddress.addInitial;
    return this._http.post(apiURL, reqModel).pipe();
  }

  changeDefaultInitial(reqModel): Observable<any> {
    const apiURL = this.baseManageUserUrl + this.apiAddress.changeDefaultInitial;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getSignaturesAndInitials(reqModel): Observable<any> {
    const apiURL = this.baseManageUserUrl + this.apiAddress.getSignaturesAndInitials;
    return this._http.post(apiURL, reqModel).pipe();
  }

  removeSignature(reqModel): Observable<any> {
    const apiURL = this.baseManageUserUrl + this.apiAddress.removeSignature;
    return this._http.post(apiURL, reqModel).pipe();
  }

  removeInitial(reqModel): Observable<any> {
    const apiURL = this.baseManageUserUrl + this.apiAddress.removeInitial;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addFilemanagerFile(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.addFileManagerFile;
    return this._http.post(apiURL, reqModel).pipe();
  }

  verifyFileManagerFolderUrl(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.verifyFileManagerFolderUrl;
    return this._http.post(apiURL, reqModel).pipe();
  }

  IsCheckIn(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.isCheckIn;  
    return this._http.post(apiURL, reqModel).pipe();
  }


  archivedTemplateUrlSentLog(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.archivedTemplateUrlSentLog;
    return this._http.post(apiURL, reqModel).pipe();
  }


  GetFileManagerFileDetail(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetFileManagerFileDetail;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddVectorFileID(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddVectorFileID;
    return this._http.post(apiURL, reqModel).pipe();
  }

  runAIButton_4o_Run_Gemini(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetGoogleGeminiResponseGetQuestionAIResponse;
    return this._http.post(apiURL, reqModel).pipe();
  }

   runAIButton_4o_Run_Gemini_NLP(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetGoogleGeminiResponseFieldsValuesforNLP;
    return this._http.post(apiURL, reqModel).pipe();
  }

  prepareOCRFiles(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.prepareOCRFiles;
    return this._http.post(apiURL, reqModel).pipe();
  }

  processDocument(url: string, userId: string, officeId: string, organizationId: string,pdftext:string=""): Observable<any> {
  const apiURL='https://pythondocumentchatapi-fud4a5bqduengkgk.eastus-01.azurewebsites.net/documents/process_document_url';
    //  const params = new HttpParams()
      //    .set('url', url)
      //    .set('UserID', userId)
      //    .set('OfficeID', officeId)
      //    .set('OrganizationID', organizationId)
      //    .set('pdftext', pdftext);
      const body = {
        url: url,
        UserID: userId,
        OfficeID: officeId,
        OrganizationID: organizationId,
        pdftext: pdftext
    };
     // return this._http.post(apiURL, null, { params, observe: 'response' }).pipe(
      return this._http.post(apiURL, body, { observe: 'response' }).pipe(
      map(response => {
        if (response.status === 200) {
          return { success: true, message: response.body['message'] };
        } else {
          return { success: false, message: response.body['message'] };
        }
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ success: false, message: error.message });
      })
    );
  }

  query_vector_dbFields(query: string, documentId: string): Observable<any> {
    const apiURL='https://pythondocumentchatapi-fud4a5bqduengkgk.eastus-01.azurewebsites.net/documents/query_vector_dbFields';
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const body = {
      query: query,
      documentid: documentId
    };

    return this._http.post(apiURL, body, { headers, observe: 'response' }).pipe(
      map(response => {
        if (response.status === 200) {
          return { success: true, response: response.body['response'] };
        } else {
          return { success: false, message: response.body['message'] };
        }
      }),
      catchError((error) => {
        return throwError({ success: false, message: error.message });
      })
    );
  }
  saveAIChatHistory(chatHistory): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.saveAIChatHistory;
    return this._http.post(apiURL, chatHistory).pipe();
  }
  GetAllAIChatHostory(chatHistory): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getAllAIChatHistory;
    return this._http.post(apiURL, chatHistory).pipe();
  }
  aiChat_Query_vector_db(query: string, documentId: string): Observable<any> {
  const apiURL='https://pythondocumentchatapi-fud4a5bqduengkgk.eastus-01.azurewebsites.net/documents/aiChatResponse';
  const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
  const body = {
    query: query,
    documentid: documentId
  };
  return this._http.post(apiURL, body, { headers, observe: 'response' }).pipe(
    map(response => {
      if (response.status === 200) {
        return { success: true, response: response.body['response'] };
      } else {
        return { success: false, message: response.body['message'] };
      }
    }),
    catchError((error) => {
      return throwError({ success: false, message: error.message });
    })
  );
}

  getFieldsValuesforNLP(query: string, ocrtextfileurl: string): Observable<any> {
    const apiURL='https://pythondocumentchatapi-fud4a5bqduengkgk.eastus-01.azurewebsites.net/documents/getFieldsValuesforNLP';
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const body = {
      query: query,
      ocrtextfileurl: ocrtextfileurl
    };

    return this._http.post(apiURL, body, { headers, observe: 'response' }).pipe(
      map(response => {
        if (response.status === 200) {
          return { success: true, response: response.body['response'] };
        } else {
          return { success: false, message: response.body['message'] };
        }
      }),
      catchError((error) => {
        return throwError({ success: false, message: error.message });
      })
    );
  }


  query_vector_db(query: string, documentId: string,prompt_input:string=""): Observable<any> {
   // const apiURL='http://127.0.0.1:8000/documents/query_vector_db';
    const apiURL='https://pythondocumentchatapi-fud4a5bqduengkgk.eastus-01.azurewebsites.net/documents/query_vector_db';
    
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const body = {
      query: query,
      documentid: documentId,
      prompt_input:prompt_input
    };

    return this._http.post(apiURL, body, { headers, observe: 'response' }).pipe(
      map(response => {
        if (response.status === 200) {
          return { success: true, response: response.body['response'] };
        } else {
          return { success: false, message: response.body['message'] };
        }
      }),
      catchError((error) => {
        return throwError({ success: false, message: error.message });
      })
    );
  }

  submit_prompt_4o(url_pdf: string,prompt_input:string="",isNta:boolean=false,pdfTextFromOCR:string=""): Observable<any> {
    //const apiURL='http://127.0.0.1:8000/documents/submit-prompt-4o';
    //const apiURL='https://pythondocumentchatapi-fud4a5bqduengkgk.eastus-01.azurewebsites.net/documents/new-submit-prompt-4o';
    const apiURL='https://pythondocumentchatapi-fud4a5bqduengkgk.eastus-01.azurewebsites.net/documents/submit-prompt-4o';
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const body = {
      url_pdf: url_pdf,
      prompt:prompt_input,
      isNta:isNta,
      pdfTextFromOCR:pdfTextFromOCR
    };

    return this._http.post(apiURL, body, { headers, observe: 'response' }).pipe(
      map(response => {
        if (response.status === 200) {
          return { success: true, response: response.body['response'] };
        } else {
          return { success: false, message: response.body['message'] };
        }
      }),
      catchError((error) => {
        return throwError({ success: false, message: error.message });
      })
    );
  }
  

  submit_prompt_4o_onGivenContext(prompt_input:string): Observable<any> {
    //const apiURL='http://127.0.0.1:8000/documents/submit-prompt-4o';
    const apiURL='https://pythondocumentchatapi-fud4a5bqduengkgk.eastus-01.azurewebsites.net/documents/submit-prompt-4o-onGivenContext';
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const body = {
      prompt:prompt_input
    };
    return this._http.post(apiURL, body, { headers, observe: 'response' }).pipe(
      map(response => {
        if (response.status === 200) {
          return { success: true, response: response.body['response'] };
        } else {
          return { success: false, message: response.body['message'] };
        }
      }),
      catchError((error) => {
        return throwError({ success: false, message: error.message });
      })
    );
  }

  new_submit_prompt_4o(ocrtextfileurl: string,prompt_input:string,isNta:boolean): Observable<any> {
    //const apiURL='http://127.0.0.1:8000/documents/submit-prompt-4o';
    const apiURL='https://pythondocumentchatapi-fud4a5bqduengkgk.eastus-01.azurewebsites.net/documents/new-submit-prompt-4o';
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const body = {
      ocrtextfileurl: ocrtextfileurl,
      prompt:prompt_input,
      isNta:isNta,
      //pdfTextFromOCR:pdfTextFromOCR
    };

    return this._http.post(apiURL, body, { headers, observe: 'response' }).pipe(
      map(response => {
        if (response.status === 200) {
          return { success: true, response: response.body['response'] };
        } else {
          return { success: false, message: response.body['message'] };
        }
      }),
      catchError((error) => {
        return throwError({ success: false, message: error.message });
      })
    );
  }

  DownloadDocument(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.DownloadDocument;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getPortalDatafor3C(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getPortalDatafor3C;
    const token = sessionStorage.getItem('LoginToken');

      // Prepare the headers
      const httpHeaders = new HttpHeaders({
        'Authorization': `Bearer ${token}`
      });
    return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();
   // return this._http.post(apiURL, reqModel).pipe();
  }

  getOfficeDetail(reqModel): Observable<any> {
    const apiURL =  this.baseURlOrg + this.apiAddress.getOfficeDetail; 
    return this._http.post(apiURL,reqModel).pipe();
  }

  getPortalUser3Cs(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getPortalUser3Cs;   
      // Retrieve the token from local storage
      const token = sessionStorage.getItem('LoginToken');

      // Prepare the headers
      const httpHeaders = new HttpHeaders({
        'Authorization': `Bearer ${token}`
      });
    return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();
  }

  CheckLoginTokenEXpiry(loginReqModel: any){
    const apiCallingURl = this.baseManageUserUrl + this.apiAddress.CheckLoginTokenEXpiry;
    return this._http.post(apiCallingURl, loginReqModel).pipe();
  }

  addNotePortal(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.addNotePortal;   
    // Retrieve the token from local storage
    const token = sessionStorage.getItem('LoginToken');

    // Prepare the headers
    const httpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });
  return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();
    // const apiURL = this.baseUrlTrans + this.apiAddress.addNotePortal;
    // return this._http.post(apiURL, reqModel).pipe();
  }

  addPersonalNotePortal(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.addPersonalNote;   
    // Retrieve the token from local storage
    const token = sessionStorage.getItem('LoginToken');

    // Prepare the headers
    const httpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });
    return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();
    // const apiURL = this.baseUrlTrans + this.apiAddress.addPersonalNote;
    // return this._http.post(apiURL, reqModel).pipe();
  }

   getPortalDataforHome(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.getPortalDataforHome;   
      // Retrieve the token from local storage
      const token = sessionStorage.getItem('LoginToken');
  
      // Prepare the headers
      const httpHeaders = new HttpHeaders({
        'Authorization': `Bearer ${token}`
      });
      return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();
      //  const apiURL = this.baseUrlTrans + this.apiAddress.getPortalDataforHome;
      //  return this._http.post(apiURL, reqModel).pipe();
    }

    getPortalBroadcastingMessages(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.getPortalBroadcastingMessages;   
      // Retrieve the token from local storage
      const token = sessionStorage.getItem('LoginToken');
  
      // Prepare the headers
      const httpHeaders = new HttpHeaders({
        'Authorization': `Bearer ${token}`
      });
      return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();
      //  const apiURL = this.baseUrlTrans + this.apiAddress.getPortalDataforHome;
      //  return this._http.post(apiURL, reqModel).pipe();
    }

    getPortalUnreadNotifications(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.getPortalUnreadNotifications;   
      // Retrieve the token from local storage
      const token = sessionStorage.getItem('LoginToken');
  
      // Prepare the headers
      const httpHeaders = new HttpHeaders({
        'Authorization': `Bearer ${token}`
      });
      return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();
      //  const apiURL = this.baseUrlTrans + this.apiAddress.getPortalDataforHome;
      //  return this._http.post(apiURL, reqModel).pipe();
    }

    
     getCompletedActionsfor3C(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.getCompletedActionsfor3C;   
      // Retrieve the token from local storage
      const token = sessionStorage.getItem('LoginToken');
  
      // Prepare the headers
      const httpHeaders = new HttpHeaders({
        'Authorization': `Bearer ${token}`
      });
      return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();
      //  const apiURL = this.baseUrlTrans + this.apiAddress.getPortalDataforHome;
      //  return this._http.post(apiURL, reqModel).pipe();
    }
    
      getPortalDocuments(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.getPortalDocuments;   
      // Retrieve the token from local storage
      const token = sessionStorage.getItem('LoginToken');
  
      // Prepare the headers
      const httpHeaders = new HttpHeaders({
        'Authorization': `Bearer ${token}`
      });
      return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();
      //  const apiURL = this.baseUrlTrans + this.apiAddress.getPortalDataforHome;
      //  return this._http.post(apiURL, reqModel).pipe();
    }

    readNotification(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.readNotification;   
      // Retrieve the token from local storage
      const token = sessionStorage.getItem('LoginToken');
  
      // Prepare the headers
      const httpHeaders = new HttpHeaders({
        'Authorization': `Bearer ${token}`
      });
      return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();
      //  const apiURL = this.baseUrlTrans + this.apiAddress.getPortalDataforHome;
      //  return this._http.post(apiURL, reqModel).pipe();
    }

    getThirdPartyApis(reqModel): Observable<any> {
      const apiURL = this.baseManageUserUrl + this.apiAddress.getThirdPartyApis;
      return this._http.post(apiURL, reqModel).pipe();
    }

    uploadCCCDocument(reqModel,type): Observable<any> {
      if (type == 1) {
        const apiURL = this.baseUrlTrans + this.apiAddress.addCoreMultiDocumentFromPortal;   
        // Retrieve the token from local storage
        const token = sessionStorage.getItem('LoginToken');
    
        // Prepare the headers
        const httpHeaders = new HttpHeaders({
          'Authorization': `Bearer ${token}`
        });
        return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();
        //  const apiURL = this.baseUrlTrans + this.apiAddress.getPortalDataforHome;
        //  return this._http.post(apiURL, reqModel).pipe();
      }
      if (type == 2) {
        const apiURL = this.baseUrlTrans + this.apiAddress.adContactMultiDocumentFromPortal;   
        // Retrieve the token from local storage
        const token = sessionStorage.getItem('LoginToken');
    
        // Prepare the headers
        const httpHeaders = new HttpHeaders({
          'Authorization': `Bearer ${token}`
        });
        return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();
        //  const apiURL = this.baseUrlTrans + this.apiAddress.getPortalDataforHome;
        //  return this._http.post(apiURL, reqModel).pipe();
      }
      if (type == 3) {
        const apiURL = this.baseUrlTrans + this.apiAddress.addCompanyMultiDocumentFromPortal;   
        // Retrieve the token from local storage
        const token = sessionStorage.getItem('LoginToken');
    
        // Prepare the headers
        const httpHeaders = new HttpHeaders({
          'Authorization': `Bearer ${token}`
        });
        return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();
        //  const apiURL = this.baseUrlTrans + this.apiAddress.getPortalDataforHome;
        //  return this._http.post(apiURL, reqModel).pipe();
      }

    
    }

    
    replaceCCCDocumentPortal(reqModel,type): Observable<any> {
      if (type == 1) {
        const apiURL = this.baseUrlTrans + this.apiAddress.uploadCoreDocument;   
        // Retrieve the token from local storage
        const token = sessionStorage.getItem('LoginToken');
    
        // Prepare the headers
        const httpHeaders = new HttpHeaders({
          'Authorization': `Bearer ${token}`
        });
        return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();
        //  const apiURL = this.baseUrlTrans + this.apiAddress.getPortalDataforHome;
        //  return this._http.post(apiURL, reqModel).pipe();
      }
      if (type == 2) {
        const apiURL = this.baseUrlTrans + this.apiAddress.uploadContactDocument;   
        // Retrieve the token from local storage
        const token = sessionStorage.getItem('LoginToken');
    
        // Prepare the headers
        const httpHeaders = new HttpHeaders({
          'Authorization': `Bearer ${token}`
        });
        return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();
        //  const apiURL = this.baseUrlTrans + this.apiAddress.getPortalDataforHome;
        //  return this._http.post(apiURL, reqModel).pipe();
      }
      if (type == 3) {
        const apiURL = this.baseUrlTrans + this.apiAddress.uploadCompanyDocument;   
        // Retrieve the token from local storage
        const token = sessionStorage.getItem('LoginToken');
    
        // Prepare the headers
        const httpHeaders = new HttpHeaders({
          'Authorization': `Bearer ${token}`
        });
        return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();
        //  const apiURL = this.baseUrlTrans + this.apiAddress.getPortalDataforHome;
        //  return this._http.post(apiURL, reqModel).pipe();
      }    
    }

    formShareOnPortal(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.formShareOnPortal;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getPortalFormsforHome(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.getPortalFormsforHome;   
      // Retrieve the token from local storage
      const token = sessionStorage.getItem('LoginToken');
  
      // Prepare the headers
      const httpHeaders = new HttpHeaders({
        'Authorization': `Bearer ${token}`
      });
      return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();
      //  const apiURL = this.baseUrlTrans + this.apiAddress.getPortalDataforHome;
      //  return this._http.post(apiURL, reqModel).pipe();
    }

    searchCore(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.searchCore;
      return this._http.post(apiURL, reqModel).pipe();
    }

    GetRelationByTaskTemplateID(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.GetRelationByTaskTemplateID;
      return this._http.post(apiURL, reqModel).pipe();
    }

    searchContact(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.searchContact;
      return this._http.post(apiURL, reqModel).pipe();
    }
  
    searchCompany(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.searchCompany;
      return this._http.post(apiURL, reqModel).pipe();
    }

        
    getSynonyms(reqModel): Observable<any> {
      const apiURL = this.settingbaseUrl + this.apiAddress.getSynonyms;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getAllFieldsForAITool(reqModel): Observable<any> {
      const apiURL = this.settingbaseUrl + this.apiAddress.getAllFieldsForAITool;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getOCRTemplateCategories(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.getOCRTemplateCategories;
      return this._http.post(apiURL, reqModel).pipe();
    }

    addField(dataModel) {
      const apiCallingURl = this.settingbaseUrl + this.apiAddress.addField;
      return this._http.post(apiCallingURl, dataModel).pipe();
    }

    
    getOCRModels(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.getOCRModels;
      return this._http.post(apiURL, reqModel).pipe();
    }

    extractDataWithFields(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.extractDataWithFields;
      return this._http.post(apiURL, reqModel).pipe();
    }

    addOcrTemplates(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.addOcrTemplate;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getOCRTemplates(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.getOCRTemplates;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getOCRTemplateFields(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.getOCRTemplateFields;
      return this._http.post(apiURL, reqModel).pipe();
    }

    addMappedKeyValueData(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.addMappedKeyValueData;
      return this._http.post(apiURL, reqModel).pipe();
    }

    SearchFieldName(dataModel: any) {
      const apiCallingURl = this.settingbaseUrl + this.apiAddress.SearchFieldName;
      return this._http.post(apiCallingURl, dataModel).pipe();
    }

    getCustomdetails(dataModel) {
      const apiCallingURl = this.settingbaseUrl + this.apiAddress.getFieldDetailForTab;
      return this._http.post(apiCallingURl, dataModel).pipe();
    }

    AddFieldFolderMappingForExistingField(dataModel) {
      const apiCallingURl = this.settingbaseUrl + this.apiAddress.AddFieldFolderMappingForExistingField;
      return this._http.post(apiCallingURl, dataModel).pipe();
    }

    getNLPTemplateCategories(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.getNLPTemplateCategories;
      return this._http.post(apiURL, reqModel).pipe();
    }

    addNLPTemplate(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.addNLPTemplate;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getNLPTemplates(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.getNLPTemplates;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getNLPQueries(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.getNLPQueries;
      return this._http.post(apiURL, reqModel).pipe();
    }

    renameNLPTemplate(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.renameNLPTemplate;
      return this._http.post(apiURL, reqModel).pipe();
    }

    activateNLPTemplate(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.activateNLPTemplate;
      return this._http.post(apiURL, reqModel).pipe();
    }

    removeNLPTemplates (reqModel): Observable<any> {
      const options = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
        body: reqModel
      };
      const apiURL = this.baseUrlTrans + this.apiAddress.removeNLPTemplates;
      return this._http.delete(apiURL, options).pipe();
    }

    updateNLPTemplate(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.updateNLPTemplate;
      return this._http.post(apiURL, reqModel).pipe();
    }

    mergePdfFiles(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.mergePdfFiles;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getCoreFeildList(reqModel): Observable<any> {
      const apiURL = this.baseUrlCore + this.apiAddress.getCoreFeildList;
      return this._http.post(apiURL, reqModel).pipe();
    }

    manageFormUrlFields(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.manageFormUrlFields;
      return this._http.post(apiURL, reqModel).pipe();
    }

    manageProjectUrlFields(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.manageProjectUrlFields;
      return this._http.post(apiURL, reqModel).pipe();
    }

    manageProjectFolderUrlParams(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.manageProjectFolderUrlParams;
      return this._http.post(apiURL, reqModel).pipe();
    }

    manageFormFolderUrlParams(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.manageFormFolderUrlParams;
      return this._http.post(apiURL, reqModel).pipe();
    }

    addFileAIPrompt(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.addFileAIPrompt;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getFileAIPrompt(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.getFileAIPrompt;
      return this._http.post(apiURL, reqModel).pipe();
    }

    SendMedicationToCore(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.SendMedicationToCore;
      return this._http.post(apiURL, reqModel).pipe();
    }

    GetAllSystemPrompt(): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.GetAllSystemPrompt;
      return this._http.get(apiURL).pipe();
    } 
    removeFileAIPrompts(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.removeFileAIPrompts;
      return this._http.post(apiURL, reqModel).pipe();
      // const options = {
      //   headers: new HttpHeaders({
      //     'Content-Type': 'application/json',
      //   }),
      //   body: reqModel
      // };
      // const apiURL = this.baseUrlTrans + this.apiAddress.removeFileAIPrompts;
      // return this._http.delete(apiURL, options).pipe();
    }

    disableSignaturePageAutofill(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.disableSignaturePageAutofill;
      return this._http.post(apiURL, reqModel).pipe();
    }

    disableUrlParameterConfiguration(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.disableUrlParameterConfiguration;
      return this._http.post(apiURL, reqModel).pipe();
    }

    disableFolderUrlParameterConfiguration(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.disableFolderUrlParameterConfiguration;
      return this._http.post(apiURL, reqModel).pipe();
    }
    
    addWebFormUserSetting(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.addWebFormUserSetting;    
      return this._http.post(apiURL, reqModel).pipe();
    }

    getPDFFormReport(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.getPDFFormReport;
      return this._http.post(apiURL, reqModel).pipe();
    }

    addPDFFormUserSetting(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.addPDFFormUserSetting;    
      return this._http.post(apiURL, reqModel).pipe();
    }

    mapCoreContactWithFinalDocuments(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.mapCoreContactWithFinalDocuments;
      return this._http.post(apiURL, reqModel).pipe();
    }

    pdfProjectAdvancedSearch(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.pdfProjectAdvancedSearch;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getFormsList(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.getFormsList;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getUserList(data: any): Observable<any> {
      const apiURL = this.baseManageUserUrl + this.apiAddress.userList;
      return this._http.post(apiURL, data).pipe();
    }

    AddCreateProjectforPlaceholderCore(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.AddCreateProjectforPlaceholderCore;
      return this._http.post(apiURL, reqModel).pipe();
    }

    AddCreateProjectforPlaceholderContact(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.AddCreateProjectforPlaceholderContact;
      return this._http.post(apiURL, reqModel).pipe();
    }

    AddCreateProjectforPlaceholderCompany(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.AddCreateProjectforPlaceholderCompany;
      return this._http.post(apiURL, reqModel).pipe();
    }

   
    reorderFileAIPrompt(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.reorderFileAIPrompt;
      return this._http.post(apiURL, reqModel).pipe();
    }

    resendEmailtoParticipants(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.resendEmailtoParticipants;
      return this._http.post(apiURL, reqModel).pipe();
    }
    
    pushMergedDocumentsTo3C(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.pushMergedDocumentsTo3C;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getMergedFileHistory(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.getMergedFileHistory;
      return this._http.post(apiURL, reqModel).pipe();
    }

    GetUserList(reqModel): Observable<any> {
      const apiURL = this.baseManageUserUrl + this.apiAddress.GetUserList;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getTypeOfParticipant(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.getTypeOfParticipants;
      return this._http.post(apiURL,reqModel).pipe();
    }

    changeParticipantColor(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.changeParticipantColor;
      return this._http.post(apiURL, reqModel).pipe();
    }

    changeParticipantFromSignaturePage(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.changeParticipantFromSignaturePage;
      return this._http.post(apiURL, reqModel).pipe();
    }

     canThisPdfOpenforModifyByBytes(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.canThisPdfOpenforModifyByBytes;
      return this._http.post(apiURL, reqModel).pipe();
    }

     canThisPdfOpenforModifyByUrl(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.canThisPdfOpenforModifyByUrl;
      return this._http.post(apiURL, reqModel).pipe();
    }

    uploadPortalDocinChunks(reqModel): Observable<any> {     
        const apiURL = this.baseUrlTrans + this.apiAddress.uploadPortalDocinChunks;
       // const apiURL = 'https://localhost:65454/' + this.apiAddress.uploadPortalDocinChunks;
        // Retrieve the token from local storage
        const token = sessionStorage.getItem('LoginToken');
    
        // Prepare the headers
        const httpHeaders = new HttpHeaders({
          'Authorization': `Bearer ${token}`
        });
        return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();       
     }       

     getPortalDocumentPages(reqModel): Observable<any> {     
        const apiURL = this.baseUrlTrans + this.apiAddress.getPortalDocumentPages;
       // const apiURL = 'https://localhost:65454/' + this.apiAddress.uploadPortalDocinChunks;
        // Retrieve the token from local storage
        const token = sessionStorage.getItem('LoginToken');
    
        // Prepare the headers
        const httpHeaders = new HttpHeaders({
          'Authorization': `Bearer ${token}`
        });
        return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();       
      }  
  
    //  uploadPortalDocinChunks(reqModel):Observable<any>{
    //    const apiURL = this.baseUrlTrans + this.apiAddress.uploadPortalDocinChunks;
    //    return this._http.post(apiURL, reqModel).pipe();
    //  }
}
